import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Dropdown } from "semantic-ui-react";
import { useSearchParams } from "react-router-dom";
import styles from "./Filtration.module.scss";

const categoryOptions = [
  { key: 'all', text: 'Wszystkie', value: '' },
  { key: 'dresses', text: 'Sukienki', value: 'dresses' },
  { key: 'skirts', text: 'Spódnice', value: 'skirts' },
  { key: 'trousers', text: 'Spodnie', value: 'trousers' },
  { key: 'blouses', text: 'Bluzki', value: 'blouses' },
  { key: 'shirts', text: 'Koszule', value: 'shirts' },
  { key: 'tshirts', text: 'T-shirty', value: 'tshirts' },
  { key: 'sweaters', text: 'Swetry', value: 'sweaters' },
  { key: 'jackets', text: 'Kurtki', value: 'jackets' },
  { key: 'shorts', text: 'Szorty', value: 'shorts' },
];

const clientOptions = [
  { key: 'all', text: 'Wszyscy', value: '' },
  { key: 'female', text: 'Kobieta', value: 'female' },
  { key: 'male', text: 'Mężczyzna', value: 'male' },
  { key: 'girl', text: 'Dziewczynka', value: 'girl' },
  { key: 'boy', text: 'Chłopiec', value: 'boy' },
  { key: 'infant', text: 'Niemowlę', value: 'infant' },
  { key: 'unisex', text: 'Unisex', value: 'unisex' },
];

const Filtration = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showFilters, setShowFilters] = useState(false);
  const [category, setCategory] = useState(searchParams.get('category') || '');
  const [client, setClient] = useState(searchParams.get('client') || '');

  const handleCategoryChange = (_e: any, { value }: any) => {
    setCategory(value);
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set('category', value);
    } else {
      newParams.delete('category');
    }
    setSearchParams(newParams);
  };

  const handleClientChange = (_e: any, { value }: any) => {
    setClient(value);
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set('client', value);
    } else {
      newParams.delete('client');
    }
    setSearchParams(newParams);
  };

  return (
    <nav className={styles.filtration}>
      <button onClick={() => setShowFilters(!showFilters)}>
        <FormattedMessage id="nav.filters" defaultMessage="Filters" />{" "}
        <img
          src="https://cdn4.iconfinder.com/data/icons/ui-admin-side-menu-set-32-vol-1/40/Filter2x-512.png"
          alt="filter"
        />
      </button>
      {showFilters && (
        <div className={styles.filtersDropdowns}>
          <Dropdown
            placeholder="Kategoria"
            selection
            options={categoryOptions}
            value={category}
            onChange={handleCategoryChange}
            className={styles.filterDropdown}
          />
          <Dropdown
            placeholder="Dla kogo"
            selection
            options={clientOptions}
            value={client}
            onChange={handleClientChange}
            className={styles.filterDropdown}
          />
        </div>
      )}
    </nav>
  );
};

export default Filtration;
